(function () {
  'use strict';
  if (customElements.get('blovo-customer-stories')) return;
  var payloads = new Map();
  function normalize(value) { return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase(); }
  function text(node) { return node ? String(node.textContent || '').trim().replace(/\s+/g, ' ') : ''; }
  function imageUrl(value) {
    try { var url = new URL(value, window.location.origin); return url.protocol === 'https:' ? url.href : ''; } catch (e) { return ''; }
  }
  function productUrl(value) {
    try { var url = new URL(value, window.location.origin); return url.origin === window.location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname) ? url.pathname + url.search : ''; } catch (e) { return ''; }
  }
  function parseReviews(html, cfg) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    var seen = new Set();
    return Array.from(doc.querySelectorAll('.jdgm-carousel-item')).map(function (item) {
      var id = item.getAttribute('data-review-id') || '';
      if (id && seen.has(id)) return null;
      if (id) seen.add(id);
      var bodyNode = item.querySelector('.jdgm-carousel-item__review-body');
      var paragraphs = bodyNode && bodyNode.querySelectorAll('p');
      var body = paragraphs && paragraphs.length ? Array.from(paragraphs).map(text).join('\n\n') : text(bodyNode);
      var title = text(item.querySelector('.jdgm-carousel-item__review-title'));
      if (!body && !title) return null;
      var productTitle = text(item.querySelector('.jdgm-carousel-item__product-title'));
      var picture = item.querySelector('.jdgm-carousel-item__image-wrapper img');
      var image = picture ? imageUrl(picture.getAttribute('data-src-retina') || picture.getAttribute('data-src') || picture.getAttribute('src')) : '';
      if (cfg.picturesOnly && !image) return null;
      var ratingNode = item.querySelector('.jdgm-carousel-item__review-rating');
      var match = ratingNode && (ratingNode.getAttribute('aria-label') || '').match(/([0-5](?:\.\d+)?)/);
      var rating = match ? Number(match[1]) : ratingNode ? ratingNode.querySelectorAll('.jdgm--on').length : null;
      var product = (cfg.products || []).find(function (p) { return p.title && normalize(p.title) === normalize(productTitle); });
      return { id: id, body: body || title, title: title, author: text(item.querySelector('.jdgm-carousel-item__reviewer-name')) || cfg.labels.customer, image: image, rating: rating, productTitle: productTitle, productUrl: product && productUrl(product.url) };
    }).filter(Boolean).slice(0, Math.max(3, Math.min(15, Number(cfg.maxReviews) || 12)));
  }
  function getWidget(name, cfg) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 15000);
    var url = new URL('https://api.judge.me/api/v1/widgets/' + name);
    url.searchParams.set('shop_domain', cfg.shop);
    // Public widget token, explicitly designed for storefront GET requests.
    url.searchParams.set('api_token', cfg.token);
    return fetch(url.toString(), { credentials: 'omit', referrerPolicy: 'no-referrer', signal: controller.signal }).then(function (response) {
      if (!response.ok) throw new Error('reviews_unavailable');
      return response.json();
    }).finally(function () { window.clearTimeout(timeout); });
  }
  function loadPayload(cfg, retry) {
    var key = cfg.shop + ':' + cfg.token;
    var cached = payloads.get(key);
    if (!retry && cached && Date.now() - cached.at < 300000) return cached.promise;
    var promise = Promise.allSettled(['featured_carousel', 'all_reviews_rating', 'all_reviews_count'].map(function (name) { return getWidget(name, cfg); })).then(function (result) {
      if (result[0].status !== 'fulfilled' || typeof result[0].value.featured_carousel !== 'string') throw new Error('reviews_unavailable');
      var rating = result[1].status === 'fulfilled' ? Number(result[1].value.all_reviews_rating) : NaN;
      var count = result[2].status === 'fulfilled' ? Number(result[2].value.all_reviews_count) : NaN;
      return { html: result[0].value.featured_carousel, rating: rating >= 0 && rating <= 5 ? rating : null, count: Number.isInteger(count) && count > 0 ? count : null };
    }).catch(function (error) { payloads.delete(key); throw error; });
    payloads.set(key, { at: Date.now(), promise: promise });
    return promise;
  }
  function node(tag, cls, value) { var el = document.createElement(tag); if (cls) el.className = cls; if (value != null) el.textContent = value; return el; }
  class CustomerStories extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-stories-config]').textContent); } catch (e) { return; }
      this.track = this.querySelector('[data-stories-track]');
      this.dots = this.querySelector('[data-stories-dots]');
      this.status = this.querySelector('[data-stories-status]');
      this.dialog = this.querySelector('[data-stories-dialog]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.page = 0;
      this.perPage = this.mobile.matches ? 2 : 3;
      this.abort = new AbortController();
      var options = { signal: this.abort.signal };
      var self = this;
      this.autoPaused = false;
      this.inView = false;
      this.pointerActive = false;
      this.hovered = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pauseButton = node('button', 'blovo-stories__arrow');
      this.pauseButton.type = 'button';
      this.pauseButton.dataset.storiesAutoplay = '';
      this.querySelector('[data-stories-navigation]').appendChild(this.pauseButton);
      this.pauseButton.addEventListener('click', function () { self.autoPaused = !self.autoPaused; self.resumeWithFocus = !self.autoPaused; self.scheduleAutoplay(); }, options);
      this.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') { self.hovered = true; self.scheduleAutoplay(); } }, options);
      this.addEventListener('pointerleave', function (event) { if (event.pointerType === 'mouse') { self.hovered = false; self.scheduleAutoplay(); } }, options);
      this.addEventListener('focusin', function () { self.resumeWithFocus = false; self.scheduleAutoplay(); }, options);
      this.addEventListener('focusout', function () { window.setTimeout(function () { if (self.isConnected) self.scheduleAutoplay(); }, 0); }, options);
      this.track.addEventListener('pointerdown', function () { self.pointerActive = true; self.scheduleAutoplay(); }, options);
      window.addEventListener('pointerup', function () { if (self.pointerActive) { self.pointerActive = false; self.scheduleAutoplay(); } }, options);
      window.addEventListener('pointercancel', function () { self.pointerActive = false; self.scheduleAutoplay(); }, options);
      document.addEventListener('visibilitychange', function () { self.scheduleAutoplay(); }, options);
      this.motion.addEventListener('change', function () { self.scheduleAutoplay(); }, options);
      this.dialog.addEventListener('close', function () { self.scheduleAutoplay(); }, options);
      this.playObserver = new IntersectionObserver(function (entries) { self.inView = entries[0].isIntersecting; self.scheduleAutoplay(); }, { threshold: .15 });
      this.playObserver.observe(this);
      this.querySelectorAll('[data-stories-direction]').forEach(function (button) { button.addEventListener('click', function () { self.go(self.page + Number(button.dataset.storiesDirection)); }, options); });
      this.querySelector('[data-stories-retry]').addEventListener('click', function () { self.load(true); }, options);
      this.querySelector('[data-stories-close]').addEventListener('click', function () { self.dialog.close(); }, options);
      this.dialog.addEventListener('click', function (event) { if (event.target === self.dialog) { var r = self.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) self.dialog.close(); } }, options);
      this.track.addEventListener('scroll', function () { if (self.frame) return; self.frame = requestAnimationFrame(function () { self.frame = null; self.sync(Math.round(self.track.scrollLeft / (self.track.clientWidth || 1))); }); }, options);
      this.mobile.addEventListener('change', function () { var start = self.page * self.perPage; self.perPage = self.mobile.matches ? 2 : 3; if (self.reviews) { self.render(); self.go(Math.floor(start / self.perPage), true); } }, options);
      if ('ResizeObserver' in window) { this.resize = new ResizeObserver(function () { if (self.reviews) self.go(self.page, true); }); this.resize.observe(this.track); }
      if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) { this.observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) { self.observer.disconnect(); self.load(false); } }, { rootMargin: '400px' }); this.observer.observe(this); }
      else this.load(false);
    }
    disconnectedCallback() {
      window.clearTimeout(this.autoTimer);
      if (this.playObserver) this.playObserver.disconnect();
      if (this.pauseButton) this.pauseButton.remove();
      if (this.abort) this.abort.abort();
      if (this.observer) this.observer.disconnect();
      if (this.resize) this.resize.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.started = false;
    }
    async load(retry) {
      if (this.loading) return;
      this.loading = true;
      this.status.hidden = false;
      this.status.textContent = this.cfg.labels.loading;
      this.querySelector('[data-stories-retry]').hidden = true;
      this.querySelector('[data-stories-content]').setAttribute('aria-busy', 'true');
      try {
        if (!this.cfg.shop || !this.cfg.token) throw new Error('reviews_unconfigured');
        var payload = await loadPayload(this.cfg, retry);
        if (!this.isConnected) return;
        this.reviews = parseReviews(payload.html, this.cfg);
        this.render();
        this.summary(payload);
      } catch (e) {
        if (!this.isConnected) return;
        this.status.textContent = this.cfg.labels.error;
        this.querySelector('[data-stories-retry]').hidden = false;
        window.clearTimeout(this.autoTimer);
        this.track.hidden = true;
        this.querySelector('[data-stories-navigation]').hidden = true;
        this.querySelector('[data-stories-attribution]').hidden = true;
        this.querySelector('[data-stories-summary]').hidden = true;
      } finally {
        this.loading = false;
        if (this.isConnected) this.querySelector('[data-stories-content]').setAttribute('aria-busy', 'false');
      }
    }
    summary(payload) {
      var summary = this.querySelector('[data-stories-summary]');
      summary.hidden = payload.rating == null || payload.count == null;
      if (summary.hidden) return;
      var formatted = payload.rating.toLocaleString(this.cfg.locale || 'en', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
      this.querySelector('[data-stories-score]').textContent = formatted;
      var stars = this.querySelector('[data-stories-stars]');
      stars.style.setProperty('--stars-fill', payload.rating / 5 * 100 + '%');
      stars.setAttribute('aria-label', this.cfg.labels.rating.replace('[rating]', formatted));
      this.querySelector('[data-stories-count]').textContent = this.cfg.labels.review_count.replace('[count]', payload.count.toLocaleString(this.cfg.locale || 'en'));
    }
    card(review) {
      var self = this;
      var article = node('article', 'blovo-stories__card');
      article.dataset.reviewId = review.id;
      var picture = node(review.productUrl ? 'a' : 'button', 'blovo-stories__image-link');
      if (review.productUrl) { picture.href = review.productUrl; picture.setAttribute('aria-label', review.productTitle); }
      else { picture.type = 'button'; picture.setAttribute('aria-label', this.cfg.labels.read_more + ': ' + review.author); picture.addEventListener('click', function () { self.openReview(review); }); }
      if (review.image) { var img = node('img'); img.src = review.image; img.alt = review.productTitle || review.author; img.width = 800; img.height = 1067; img.loading = 'lazy'; img.decoding = 'async'; picture.appendChild(img); }
      else picture.appendChild(node('span', 'blovo-stories__image-placeholder', review.author.charAt(0)));
      article.appendChild(picture);
      var body = node('div', 'blovo-stories__body');
      if (review.rating != null) { var stars = node('span', 'blovo-stories__stars', '★★★★★'); stars.style.setProperty('--stars-fill', Math.max(0, Math.min(5, review.rating)) / 5 * 100 + '%'); stars.setAttribute('role', 'img'); stars.setAttribute('aria-label', this.cfg.labels.rating.replace('[rating]', String(review.rating))); body.appendChild(stars); }
      body.appendChild(node('p', 'blovo-stories__quote', review.body));
      body.appendChild(node('p', 'blovo-stories__author', '— ' + review.author));
      var read = node('button', 'blovo-stories__read', this.cfg.labels.read_more); read.type = 'button'; read.addEventListener('click', function () { self.openReview(review); }); body.appendChild(read);
      article.appendChild(body);
      return article;
    }
    render() {
      var self = this;
      this.track.replaceChildren();
      this.dots.replaceChildren();
      this.pages = Math.ceil(this.reviews.length / this.perPage);
      this.status.hidden = this.reviews.length > 0;
      this.status.textContent = this.cfg.labels.empty;
      this.track.hidden = !this.reviews.length;
      this.querySelector('[data-stories-navigation]').hidden = this.pages <= 1;
      this.querySelector('[data-stories-attribution]').hidden = !this.reviews.length;
      for (var index = 0; index < this.pages; index++) {
        var slide = node('div', 'blovo-stories__slide');
        this.reviews.slice(index * this.perPage, (index + 1) * this.perPage).forEach(function (review) { slide.appendChild(self.card(review)); });
        this.track.appendChild(slide);
        var dot = node('button', 'blovo-stories__dot'); dot.type = 'button'; dot.dataset.storiesPage = index; dot.setAttribute('aria-controls', this.track.id); dot.setAttribute('aria-label', this.cfg.labels.page.replace('[page]', String(index + 1))); dot.addEventListener('click', function (event) { self.go(Number(event.currentTarget.dataset.storiesPage)); }); this.dots.appendChild(dot);
      }
      this.sync(Math.min(this.page, Math.max(0, this.pages - 1)));
      this.scheduleAutoplay();
    }
    sync(page) {
      this.page = Math.max(0, Math.min(page, (this.pages || 1) - 1));
      var self = this;
      this.querySelectorAll('[data-stories-direction]').forEach(function (button) { button.disabled = Number(button.dataset.storiesDirection) < 0 ? self.page === 0 : self.page >= (self.pages || 1) - 1; });
      this.dots.querySelectorAll('button').forEach(function (dot, index) { dot.setAttribute('aria-current', index === self.page ? 'true' : 'false'); });
    }
    go(page, instant) {
      this.sync(page);
      this.track.scrollTo({ left: this.page * this.track.clientWidth, behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      this.scheduleAutoplay();
    }
    scheduleAutoplay() {
      window.clearTimeout(this.autoTimer);
      if (!this.pauseButton) return;
      var chinese = /^zh/i.test(this.cfg.locale || '');
      var label = this.autoPaused ? (chinese ? '播放评价轮播' : 'Play review slideshow') : (chinese ? '暂停评价轮播' : 'Pause review slideshow');
      this.pauseButton.textContent = this.autoPaused ? '▶' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', label);
      this.pauseButton.title = label;
      this.pauseButton.setAttribute('aria-pressed', this.autoPaused ? 'true' : 'false');
      this.pauseButton.hidden = this.motion.matches;
      var focused = this.contains(document.activeElement) && !(this.resumeWithFocus && document.activeElement === this.pauseButton);
      if (!this.isConnected || !this.inView || document.hidden || this.autoPaused || this.hovered || this.pointerActive || focused || this.dialog.open || this.motion.matches || this.pages <= 1 || this.track.hidden) return;
      var self = this;
      this.autoTimer = window.setTimeout(function () { self.go((self.page + 1) % self.pages); }, 6000);
    }
    openReview(review) {
      window.clearTimeout(this.autoTimer);
      this.querySelector('[data-stories-dialog-title]').textContent = review.title || review.author;
      this.querySelector('[data-stories-dialog-author]').textContent = review.author;
      this.querySelector('[data-stories-dialog-body]').textContent = review.body;
      var product = this.querySelector('[data-stories-dialog-product]'); product.hidden = !review.productUrl; if (review.productUrl) product.href = review.productUrl; else product.removeAttribute('href');
      this.dialog.showModal();
    }
  }
  customElements.define('blovo-customer-stories', CustomerStories);
})();
